import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const UsersList = Loadable(lazy(() => import('./UserList')));

const userRoutes = [{ path: '/users', element: <UsersList />, auth: authRoles.admin }];

export default userRoutes;
